export type {
  ContactUpdateRequest,
  ContactUpdateResponse,
  CreateNextOfKin,
  CreateRequest,
  CreateResponse,
  GeneralUpdateRequest,
  GeneralUpdateResponse,
  GetResponse,
  NextOfKin,
  PartialNextOfKin,
} from './schema';

export {
  nextOfKinContactSchema,
  nextOfKinGeneralSchema,
  nextOfKinSchema,
} from './validation';
